export default __webpack_public_path__ + "static/media/expert.5f7b1685.svg";